import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {ContentScore} from './ContentScore';
import {useTranslation} from 'next-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {Progress} from 'antd';
import {getProgressColor} from '@/utils/colors';
import {WordCount} from './WordCount/WordCount';
import {SidebarTooltip} from '../../Common/SideBarTooltip/sidebarTooltip';
import {Dispatch, SetStateAction} from 'react';
interface HeaderSectionProps {
  setViewSuggestionsOption: Dispatch<SetStateAction<boolean>>;
  setLinksDropDownFromSuggestion: Dispatch<SetStateAction<any>>;
}

export const HeaderSection = observer(({setViewSuggestionsOption, setLinksDropDownFromSuggestion}: HeaderSectionProps) => {
  const {t} = useTranslation('common');
  const {
    contentOptimizer: {
      currentPage: {
        isScoreLoading,
        focusTermsExpanded,
        isTaActive,
        isLinkActive,
        content: {
          score,
        },
      },
    }} = useStore('');


  return <>
    { (!focusTermsExpanded && (!isTaActive && !isLinkActive)) ? <Container>
      <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 10}}>
        <TitleContainer>
          <Title>{t('content-score')}</Title>
          <SidebarTooltip title={'Content Score is a number between 1 and 100 that grades content quality and relevancy. The score is the average content score of all evaluated target keywords'}>
            <FontAwesomeIcon icon={faCircleInfo} style={{marginLeft: 5}}/>
          </SidebarTooltip>
        </TitleContainer>

      </div>
      <ContentScore setLinksDropDownFromSuggestion={setLinksDropDownFromSuggestion} setViewSuggestionsOption={setViewSuggestionsOption}/>

    </Container> : <MiniContainer>
      <ScoreAndWordCount>
        <ProgressStyled
          percent={!isScoreLoading ? score ?? 0 : 50}
          strokeLinecap='round'
          gapDegree={140}
          gapPosition={'bottom'}
          trailColor='#4E5156'
          strokeColor={!isScoreLoading ? getProgressColor(score, 25, 50, 75) : '#7E8184'}
          showInfo={true}
          type='dashboard'
          width={50}
          strokeWidth={10}
          size='small'
          format={() => <span style={{color: '#fff', fontSize: '18px', fontWeight: 'bold'}}>{!isScoreLoading ? (score ?? '-') : '-'}</span>} />
        <RightSection>
          <MiniTitleContainer>
            <Title>{t('content-score')}</Title>
            <SidebarTooltip title={'Content Score is a number between 1 and 100 that grades content quality and relevancy'}
              overlayInnerStyle={{borderRadius: 10, fontSize: 12}}>
              <FontAwesomeIcon icon={faCircleInfo} style={{marginLeft: 5}}/>
            </SidebarTooltip>
          </MiniTitleContainer>
          <WordCount />
        </RightSection>
      </ScoreAndWordCount>
    </MiniContainer>}
  </>;
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 10px;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
const MiniTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;
const Title = styled.div`
  font-weight: 500;
  line-height: 17px;
  color: #fff;
`;
const ProgressStyled = styled(Progress)`
  .ant-progress-text {
    top: 40%;
  }
`;

const MiniContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 50px;
`;

const ScoreAndWordCount = styled.div`
  display: flex;
`;
const RightSection = styled.div`
  margin-left: 10px;
`;

